import { MessageEnvelope } from '@cds/push';
import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';
import { createAction, props } from '@ngrx/store';

import { BetslipState } from '../../core/betslip-state';
import { BetslipType } from '../../core/betslip-type';
import { LinearTypes } from '../../core/linear-types';

export class BetslipActions {
    static readonly ACTION_SCHEMA = '@betslip';

    private static readonly SET_STATE = `${BetslipActions.ACTION_SCHEMA}/SET_STATE`;
    private static readonly EVENT_UPDATE = `${BetslipActions.ACTION_SCHEMA}/EVENT_UPDATE`;
    private static readonly FIXTURE_UPDATE = `${BetslipActions.ACTION_SCHEMA}/FIXTURE_UPDATE`;
    private static readonly TOGGLE_BETSLIP_DISPLAY_MODE = `${BetslipActions.ACTION_SCHEMA}/TOGGLE_BETSLIP_DISPLAY_MODE`;
    private static readonly LINEAR_USER_EXPANDED_SECTIONS_UPDATE = `${BetslipActions.ACTION_SCHEMA}/LINEAR_USER_EXPANDED_SECTIONS_UPDATE`;
    private static readonly SET_LINEAR_USER_EXPANDED_SECTION = `${BetslipActions.ACTION_SCHEMA}/SET_LINEAR_USER_EXPANDED_SECTION`;
    private static readonly CLEAR_LINEAR_USER_EXPANDED_SECTIONS = `${BetslipActions.ACTION_SCHEMA}/CLEAR_LINEAR_USER_EXPANDED_SECTIONS`;

    static setState = createAction(BetslipActions.SET_STATE, props<{ state: BetslipState }>());
    static eventUpdate = createAction(BetslipActions.EVENT_UPDATE, props<{ message: MessageEnvelope }>());
    static fixtureUpdate = createAction(BetslipActions.FIXTURE_UPDATE, props<{ message: MessageEnvelope }>());
    static betBuilderGroupUpdate = createAction(`${BetslipActions.ACTION_SCHEMA}/BETBUILDER_GROUP_UPDATE`, props<{ message: MessageEnvelope }>());
    static toggleBetslipDisplayMode = createAction(BetslipActions.TOGGLE_BETSLIP_DISPLAY_MODE, props<{ mode: BetslipDisplayMode }>());
    static linearUserExpandedSectionsUpdate = createAction(
        BetslipActions.LINEAR_USER_EXPANDED_SECTIONS_UPDATE,
        props<{ userExpandedSections: LinearTypes }>(),
    );

    static setLinearUserExpandedSection = createAction(
        BetslipActions.SET_LINEAR_USER_EXPANDED_SECTION,
        props<{ betslipType: Exclude<BetslipType, BetslipType.EditBet>; isExpanded: boolean }>(),
    );

    static clearLinearUserExpandedSections = createAction(BetslipActions.CLEAR_LINEAR_USER_EXPANDED_SECTIONS);
}
